<template>
  <div>
    <div
      v-if="isLoadingReport"
      class="py-10 px-4"
    >
      <span
        class="flex flex-col mt-1"
      >
        <aha-skeleton-loader
          class="mb-1"
          width="90%"
          height="12px"
        />
        <aha-skeleton-loader
          class="mb-1"
          width="70%"
          height="12px"
        />
        <aha-skeleton-loader
          width="30%"
          height="12px"
        />
      </span>
    </div>
    <div
      v-if="feedbackLength && !isLoadingReport"
      class="report-private-feedback"
    >
      <div class="box-ratting">
        <div v-if="uniqueParticipants > 1" class="text-center font-bold">
          Rated by {{ uniqueParticipants }} participants
        </div>
        <div v-else class="text-center font-bold">
          Rated by {{ uniqueParticipants }} participant
        </div>
        <div class="rating">
          <div class="rating-content">
            <div
              class="rating-bar"
              :style="{
                '--width': `${feedbackRating * 33.33}%`
              }"
            />
            <div class="rating-section">
              <div
                class="rating-marker"
                :class="{
                  'max': feedbackRating === 3,
                  'min': feedbackRating === 0
                }"
                :style="{
                  left: `${feedbackRating * 33.33}%`
                }"
              >
                <span class="rating-marker-placeholder">
                  <img :src="rating[feedbackRating].marker" alt="">
                </span>
                <span class="rating-marker-title">{{ rating[feedbackRating].title }}</span>
              </div>
            </div>
          </div>
        </div> <!-- /.rating -->
      </div>
      <div
        class="box-feedback"
        :class="{
          'over-box': feedbackMessages && feedbackMessages.length > 4
        }"
      >
        <div
          v-for="item in feedbackMessages"
          :key="item.id"
          class="feedback-item"
        >
          <div
            class="feedback-avatar"
            :style="{
              background: item.audienceColor || '#4f9af2'
            }"
          >
            <span v-if="item.audienceEmoji">{{ item.audienceEmoji }}</span>
            <span v-else-if="item.audienceName" class="leading-normal">
              {{ item.audienceName[0] }}
            </span>
            <font-awesome-icon v-else icon="user" size="sm" />
          </div>
          <div class="feedback-msg-box bg-secondary-15 p-3">
            <div class="font-bold">
              {{ item.audienceName || 'Anonymous' }}
            </div>
            <div>{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!feedbackLength && !isLoadingReport"
      class="text-center py-6 px-4"
    >
      <div class="inline-block mb-6">
        <img
          src="@/assets/images/report/feedback.svg"
          width="172"
          height="100"
          alt=""
        >
      </div>

      <div class="font-bold mb-1">
        No feedback yet.
      </div>
      <div class=" text-sm">
        But keep it up! Your work's making impacts.
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const markerA = require('@/assets/images/feedback/could_be_better.svg')
const markerB = require('@/assets/images/feedback/not_bad.svg')
const markerC = require('@/assets/images/feedback/great.svg')
const markerD = require('@/assets/images/feedback/cant_wait.svg')

export default {
  data() {
    return {
      rating: [
        {
          marker: markerA,
          title: 'Could be better',
        },
        {
          marker: markerB,
          title: 'Not bad',
        },
        {
          marker: markerC,
          title: 'Good',
        },
        {
          marker: markerD,
          title: 'Can\'t wait for the next!',
        },
      ],
    }
  },
  computed: {
    ...mapGetters('presentationReport', [
      'privateFeedbacks',
      'isLoadingReport',
    ]),
    feedbackLength() {
      return (this.privateFeedbacks && this.privateFeedbacks.length) || 0
    },
    uniqueParticipants() {
      return this.privateFeedbacks &&
        [...new Set(this.privateFeedbacks.map((item) => item.audience))].length
    },
    feedbackMessages() {
      return this.privateFeedbacks && this.privateFeedbacks.filter((item) => item.title)
    },
    feedbackRating() {
      if (this.privateFeedbacks) {
        const voteCount = this.privateFeedbacks.reduce((total, current) => {
          return total + current.voteCount
        }, 0)

        const avg = this.feedbackLength > 0
          ? Math.round(voteCount / this.feedbackLength)
          : 0

        return avg > 3 ? 3 : avg // include data test
      }

      return 0
    },
  },
}
</script>

<style lang="scss" scoped>
.report-private-feedback {
  margin-top: 20px;
}

.box-ratting {
  padding: 10px;
  background: #FFFFFF;
  border-radius: 8px;
  background: url('~@/assets/images/feedback/background.png');
  background-position: center;
  background-size: cover;
}

.rating {
  position: relative;

  &-content {
    position: relative;
    max-width: 250px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 16px;
    padding-bottom: 30px;
  }

  &-bar {
    position: absolute;
    width: 100%;
    height: 16px;
    border: 1px solid #D3D7E1;
    border-radius: 14px;
    background-color: #fff;

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      height: 100%;
      border-radius: inherit;
      background-color: #348EF6;
      width: var(--width);
    }
  }

  .rating-section {
    position: relative;
    height: 16px;
  }

  .rating-checkpoint {
    position: absolute;
    width: 17px;
    height: 17px;
    background-color: #89BEFA;
    border-radius: 50%;
    padding: 1px;
    filter: drop-shadow(-1.19955px 0.399849px 1.59939px rgba(0, 0, 0, 0.22));
    top: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;

    &-placeholder {
      display: inline-block;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      border: 2px solid #4F9BF3;
      background-color: #fff;
    }
  }

  .rating-marker {
    position: absolute;
    background-color: #89BEFA;
    border-radius: 50%;
    filter: drop-shadow(-3px 1px 4px rgba(0, 0, 0, 0.22));
    width: 42px;
    height: 42px;
    padding: 4px;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;

    &-placeholder {
      display: flex;
      height: 100%;
      background-color: #fff;
      border: 2px solid #4F9BF3;
      border-radius: 50%;
      padding: 4px;
    }

    img {
      max-width: 100%;
      height: auto;
    }

    &-title {
      position: absolute;
      left: 50%;
      font-size: 0.75rem;
      line-height: 1rem;
      font-weight: bold;
      transform: translateX(-50%);
      bottom: -18px;
      width: max-content;
    }

    &.max {
      .rating-marker-title {
        left: auto;
        right: 0;
        transform: translateX(0);
      }
    }

    &.min {
      .rating-marker-title {
        left: 0;
        transform: translateX(0);
      }
    }
  }
}

.box-feedback {
  @apply my-5;
  overflow-y: auto;
  max-height: 300px;

  &.over-box {
    padding-right: 10px;
  }
}

.feedback-item {
  @apply flex;

  & + & {
    @apply mt-3;
  }
}

.feedback-avatar {
  @apply flex flex-shrink-0 items-center justify-center text-base-0;
  @apply mr-3;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #4f9af2;
  border: 1px solid #fff;
  text-transform: uppercase;
  font-weight: bold;

  i {
    color: #fff;
  }
}

.feedback-msg-box {
  flex-grow: 1;
  border-radius: 8px;
}
</style>
